<template>
<div class="view-wrap">
	<Heading :level="1" text="User Verification" />
	<UserMessage class="m-t-2" v-if="userVerified" message-type="success">
		<template #messageText>
			<p>Your user has been successfully verified. <router-link :to="{name: 'Login'}">Click here to login</router-link> and access your application dashboard</p>
		</template>
	</UserMessage>
	<template v-if="userMsgType">
		<UserMessage class="m-t-2" v-if="userMsgType === 409" message-type="info">
			<template #messageText>
				<p>It looks like that user has already been verified. <router-link :to="{name: 'Login'}">Click here to login</router-link> and access your application dashboard</p>
			</template>
		</UserMessage>
		<UserMessage class="m-t-2" v-else-if="userMsgType === 401" message-type="error">
			<template #messageText>
				<p>Your verification link seems to have expired. <router-link :to="{name: 'Login'}">Click here to login</router-link> to your account, to trigger a new verification email</p>
			</template>
		</UserMessage>
		<UserMessage v-else message-type="error" :message-text="error" />
	</template>
</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	data () {
		return {
			userVerified: null,
			userMsgType: null
		};
	},
	computed: {
		token () {
			return this.$route.query.avt;
		}
	},
	mounted () {
		if (this.token) {
			this.verifyUser(this.token).then((res) => {
				if (res.status === 200) {
					this.userVerified = true;
					this.userMsgType = null;
				} else {
					this.userMsgType = res.status;
					this.error = res.message;
				}
			}).catch((err) => {
				this.userMsgType = err.status;
				this.error = err.message;
			});
		}
	},
	methods: {
		...mapActions('auth', ['verifyUser'])
	}
};
</script>
